export default __webpack_public_path__ + "images/models/09ebb35638b45a49bcbc7b4a29e72c0b.usdz";